import React, { useCallback } from 'react';

import { Box, InputAdornment, Typography } from '@mui/material';
import { ViewDetailIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { openURLInNewTab } from 'utils/navigation';

const linkStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  color: 'primary.main',
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};

const preventInputFocus = e => {
  e.preventDefault();
  e.stopPropagation();
};

const TrackingAdornment = ({ trackingInfo }) => {
  const handleClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      openURLInNewTab(trackingInfo.url);
    },
    [trackingInfo.url],
  );

  return (
    <InputAdornment position="end">
      <Box
        component="a"
        href={trackingInfo.url}
        rel="noopener noreferrer"
        sx={linkStyles}
        target="_blank"
        onClick={handleClick}
        onMouseDown={preventInputFocus}
      >
        <Typography color="primary.main" variant="bold12">
          {trackingInfo.carrier}
        </Typography>
        <ViewDetailIcon size={IconSize[16]} />
      </Box>
    </InputAdornment>
  );
};

TrackingAdornment.propTypes = {
  trackingInfo: PropTypes.shape({
    carrier: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default TrackingAdornment;
